module.exports = __webpack_public_path__ + "img/Rectangle 256.5b023448.png";